/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const ReceiverFirstNameColumnFormatter = (
  cellContent,
  row,
  rowIndex
) => {
  const { receiverFirstName } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {receiverFirstName ? receiverFirstName : `-`}
      </div>
      <> </>
    </>
  );
};
